"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collection = void 0;
class Collection {
    constructor() {
        this._items = [];
    }
    get() {
        return this._items;
    }
    set(item, position) {
        const currentIndex = this._items.indexOf(item);
        position = position === undefined ? this._items.length : position;
        // if item exist - remove it from array
        if (currentIndex != -1) {
            if (currentIndex < position) {
                position--;
            }
            this._items.splice(currentIndex, 1);
        }
        // add item into position
        this._items.splice(position, 0, item);
    }
    remove(item) {
        const index = this._items.indexOf(item);
        if (index != -1) {
            this._items.splice(index, 1);
        }
    }
    clear() {
        this._items = [];
    }
}
exports.Collection = Collection;
//# sourceMappingURL=Collection.js.map